<template>
  <div class="TopicClassify inner_center">
    <div class="classify-box">
      <div class="classify-item  _pointer"
           :class="{ 'ON': params.category == vo.id }"
           v-for="vo in topicClassify"
           :key="vo.id"
           @click="toggleClassify(vo)"
      >
        {{ vo.name }}
      </div>
    </div>

    <div class="sort-box switch-box">
      <div
        :style="{ 'left': switchItemLeft + 'px' }"
        class="switch-item switch-item-bar"
      />
      <div
        v-for="(vo,idx) in switchVipType"
        :key="vo.label + 'switchVipType'"
        :class="[
          { 'ON': vo.sort == params.sort}]"
        class="switch-item _pointer"
        @click="toggleVipType(vo,idx)"
      >
        <i class="iconfont" :class="vo.iconClass"/>
        <span>{{ vo.label }}</span>
      </div>
    </div>

  </div>
</template>

<script>
import UserCenterCollectTab from '@/components/user-center/collect/collect-tab'
import {USER_CENTER} from "@/constant/user-center/USER_CENTER";
import {TOPIC} from "@/constant/tupian/TOPIC";

export default {
  name: "TopicClassify",
  components: {
    UserCenterCollectTab
  },
  props: {
    topicClassify: {
      type: Array,
      default: () => []
    },
    topicClassifyId: {
      type: String | Number,
      default: 0
    },
    topicClassifySortId: {
      type: String | Number,
      default: 0
    },
    switchVipType: {
      type: Array,
      default: TOPIC.SORT_LIST  // 0个人 、 1企业
    },
    params: {
      type: Object,
      default: () => {
      }
    }
  },
  watch: {
    topicClassifySortId: {
      handler(n, o) {
        if (n) {
          this.toggleVipType(this.switchVipType[n], n);
        }
      },
      immediate: true
    },
    companyRecordState(n) {
      console.log('1111----11111111')
      if (n) {
        this.toggleVipType(this.switchVipType[1], 1);
      }
    },
    params: {
      handler(n) {
        let idx = this.switchVipType.findIndex(vo => vo.sort == n.sort)
        this.switchItemLeft = (idx) * 88 + 3 * (idx + 1);
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      collectType: 0,
      USER_CENTER,
      TOPIC,
      switchItemLeft: 3,
      index: 0
    }
  },
  methods: {
    toggleClassify(vo) {
      this.$emit('toggleClassify', vo)
    },
    toggleVipType(vo, idx) {
      this.index = idx;
      // this.vipType = idx
      this.switchItemLeft = (idx) * 88 + 3 * (idx + 1);
      this.$emit('toggleType', vo)
    }
  }
}
</script>

<style lang="scss" scoped>
.TopicClassify {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;

  .classify-box {
    display: flex;
    align-items: center;

    .classify-item {
      font-size: 17px;
      font-weight: bold;
      color: #424866;
      line-height: 20px;
      margin-right: 28px;

      &.ON {
        color: $color-primary;
      }
    }
  }

  .switch-box {
    display: inline-flex;
    border-radius: 25px;
    background: linear-gradient(90deg, #F5F6FA 0%, #F5F6FA 17%, #FBFBFD 100%);
    padding: 3px;
    overflow: hidden;
    //width: 278px;
    position: relative;

    .switch-item {
      margin-right: 3px;
      position: relative;
      z-index: 2;
      @include LayoutFlex(1);
      cursor: pointer;
      color: #8085A4;
      width: 88px;
      height: 38px;
      border-radius: 25px;
      /*background: #FFFFFF;
      box-shadow: 0px 2px 4px 0px rgba(10,37,64,0.1);
      border-radius: 25px;*/

      .iconfont {
        font-size: 20px;
        margin-right: 4px;
      }

      &:last-child {
        margin-right: 0;
      }

      &.ON {
        color: $color-primary;
        //background: #FFFFFF;
        //box-shadow: 0px 2px 4px 0px rgba(10,37,64,0.1);
        //border-radius: 25px;
      }

      @mixin IconItem($png) {
        .icon {
          @include BgImage(16px, 16px, 'user-center/collect-record/icon_#{$png}.svg?v=2');
          margin-right: 8px;
        }
        &.on {
          .icon {
            @include BgImage(16px, 16px, 'user-center/collect-record/icon_#{$png}@active.svg?v=2');
          }
        }
      }

      &.all {
        @include IconItem('all');
      }

      &.pic {
        @include IconItem('pic');
      }

      &.package {
        @include IconItem('package');
      }

      &.topic {
        @include IconItem('topic');
      }

      &.on {
        color: $color-primary;
      }

      &.switch-item-bar {
        box-shadow: 0 2px 4px 0 rgba(10, 37, 64, 0.1);
        position: absolute;
        left: 0;
        z-index: 1;
        background: #FFFFFF;
        transition: all 0.3s ease-in;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
